import { MarkovModel } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setMarkovModelList = (modelList: types.MarkovModelList) => ({
    type: inferLiteral(types.MARKOV_MODEL_LIST),
    modelList,
})
export const setMarkovModelIds = (modelIds: readonly number[]) => ({
    type: inferLiteral(types.MARKOV_MODEL_IDS),
    modelIds,
})
export const setMarkovModelView = (model: MarkovModel) => ({
    type: inferLiteral(types.MARKOV_MODEL_VIEW),
    model,
})
export const setMarkovModelEdit = (model: MarkovModel) => ({
    type: inferLiteral(types.MARKOV_MODEL_EDIT),
    model,
})
export const setMarkovModelSort = (sortColumn: keyof MarkovModel, sortOrder: OrderType) => ({
    type: inferLiteral(types.MARKOV_MODEL_SORT),
    sortColumn,
    sortOrder,
})
export const setMarkovModelFilters = (filters: types.MarkovModelFilters) => ({
    type: inferLiteral(types.MARKOV_MODEL_FILTERS),
    filters,
})
export const setMarkovModelReloadList = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_MODEL_RELOAD_LIST),
    value,
})
export const setMarkovModelReloadView = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_MODEL_RELOAD_VIEW),
    value,
})
export const setMarkovModelReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_MODEL_RELOAD_EDIT),
    value,
})
